import { ApiModule } from '@mode/legacy/data-access-model-js';
import * as angular from 'angular';
import { DowngradedSharedUtilErrorHandlingModule } from '~/modules/downgraded-angular/shared/util-error-handling.module';
import { DowngradedSharedUtilFeatureFlagsModule } from '~/modules/downgraded-angular/shared/util-feature-flags.module';
import { ModeCommonModule } from '~/modules/mode.common/common';
import { SignInOptionsModule } from '../feature-sign-in-options/sign-in-options.module';
import { SignInModule } from '../feature-sign-in/sign-in.module';
import { SignInRoutesConfig } from './app-sign-in.routes';

const SIGN_IN_DEPS = [
  ModeCommonModule,
  ApiModule,
  'ui.router',
  'ngAria',
  SignInModule,
  SignInOptionsModule,
  DowngradedSharedUtilFeatureFlagsModule,
  DowngradedSharedUtilErrorHandlingModule,
];

export const signInAppModule: angular.IModule = angular
  .module('mode.sign-in', SIGN_IN_DEPS)
  .config(SignInRoutesConfig)

  // required by app/views/sessions/new.html.erb
  .controller('ApplicationController', function () {})

  // Copied from OrgSettingsModule
  .config([
    '$locationProvider',
    ($locationProvider) => {
      const baseTagIsSet = !!document.getElementsByTagName('base').length;

      if (baseTagIsSet) {
        $locationProvider.hashPrefix('');
        $locationProvider.html5Mode({
          enabled: true,
          rewriteLinks: false,
        });
      }
    },
  ])
  // Ideally we would use setupAppModule here, but there's some divergence here that is risky
  // I tried it and it created https://github.com/mode/webapp/pull/17180
  // due to differences in compiler settings.

  .factory('httpErrorHandler', [
    function () {
      var error: any = {};

      return {
        set: function (message, detail) {
          error.message = message;
          error.detail = detail;
        },

        clear: function () {
          error = {};
        },
      };
    },
  ])

  .config([
    '$httpProvider',
    function ($httpProvider) {
      var version = $('meta[name=webapp-revision]').attr('content');
      $httpProvider.defaults.headers.common['Accept'] = 'application/vnd.mode+json';
      $httpProvider.defaults.headers.common['Webapp-Revision'] = version;
    },
  ])

  .config([
    '$compileProvider',
    function ($compileProvider) {
      $compileProvider.aHrefSanitizationTrustedUrlList(/^\s*(https?|ftp|mailto|localhost):/);
    },
  ])

  .config([
    '$sceDelegateProvider',
    function ($sceDelegateProvider) {
      $sceDelegateProvider.trustedResourceUrlList([
        'self',
        'https://assets*.mode.com/**',
        'https://*assets.mode.com/**',
        'https://assets*.modeanalytics.com/**',
        'https://modesandbox.com/**',
        'https://staging.modesandbox.com/**',
        'https://lab.modesandbox.com/**',
        'https://assets*.modesandbox.com/**',
        'http://assets*.modeanalytics.dev:3000/**',
        'http://*modeanalysis.dev:3000/**',
        'http://assets*.goat.farm:3000/**',
        'http://*.goatpen.farm:3000/**',
        'https://app.*.mode.dev:8443/**',
        'https://app-assets.*.mode.dev:8443/**',
        'https://*.modesandbox.dev:8443/**',
      ]);
    },
  ])

  // Decorate $q with .spread and .resolve methods
  // taken from Thomas Burleson's $QDecorator:
  // https://github.com/ThomasBurleson/angularjs-FlightDashboard
  .config([
    '$provide',
    function ($provide) {
      var resolveWith = function ($q) {
        return function resolved(val) {
          var deferred = $q.defer();
          deferred.resolve(val);
          return deferred.promise;
        };
      };

      $provide.decorator('$q', [
        '$delegate',
        function ($delegate) {
          if (angular.isUndefined($delegate.spread)) {
            $delegate.spread = function (targetFn, scope) {
              return function () {
                var params = [].concat(arguments[0]);
                targetFn.apply(scope, params);
              };
            };
          }

          if (angular.isUndefined($delegate.resolve)) {
            $delegate.resolve = resolveWith($delegate);
          }
          return $delegate;
        },
      ]);
    },
  ]);
